/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateAppointmentChannelDto
 */
export interface CreateUpdateAppointmentChannelDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAppointmentChannelDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAppointmentChannelDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAppointmentChannelDto
     */
    timeWindow?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateAppointmentChannelDto
     */
    channelPublic?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAppointmentChannelDto
     */
    healthcareFacilityId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateAppointmentChannelDto
     */
    examTypes?: Array<string> | null;
}

/**
 * Check if a given object implements the CreateUpdateAppointmentChannelDto interface.
 */
export function instanceOfCreateUpdateAppointmentChannelDto(value: object): value is CreateUpdateAppointmentChannelDto {
    return true;
}

export function CreateUpdateAppointmentChannelDtoFromJSON(json: any): CreateUpdateAppointmentChannelDto {
    return CreateUpdateAppointmentChannelDtoFromJSONTyped(json, false);
}

export function CreateUpdateAppointmentChannelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateAppointmentChannelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'timeWindow': json['timeWindow'] == null ? undefined : json['timeWindow'],
        'channelPublic': json['channelPublic'] == null ? undefined : json['channelPublic'],
        'healthcareFacilityId': json['healthcareFacilityId'] == null ? undefined : json['healthcareFacilityId'],
        'examTypes': json['examTypes'] == null ? undefined : json['examTypes'],
    };
}

export function CreateUpdateAppointmentChannelDtoToJSON(value?: CreateUpdateAppointmentChannelDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'timeWindow': value['timeWindow'],
        'channelPublic': value['channelPublic'],
        'healthcareFacilityId': value['healthcareFacilityId'],
        'examTypes': value['examTypes'],
    };
}

